import { APP_CONTEXTS } from "app/model"

export function isCreateAppContext(appContext: APP_CONTEXTS): boolean {
  switch (appContext) {
    case APP_CONTEXTS.CAMPAIGN_CREATE:
    case APP_CONTEXTS.FORECAST_CREATE:
    case APP_CONTEXTS.DSP_DEAL_CREATE: {
      return true
    }
    default: {
      return false
    }
  }
}

export function isForecastAppContext(appContext: APP_CONTEXTS): boolean {
  switch (appContext) {
    case APP_CONTEXTS.FORECAST_CREATE:
    case APP_CONTEXTS.FORECAST_EDIT: {
      return true
    }
    default: {
      return false
    }
  }
}

export function isDspDealAppContext(appContext: APP_CONTEXTS): boolean {
  switch (appContext) {
    case APP_CONTEXTS.DSP_DEAL_CREATE:
    case APP_CONTEXTS.DSP_DEAL_EDIT: {
      return true
    }
    default: {
      return false
    }
  }
}
